import { Component } from '@angular/core';

@Component({
  selector: 'app-header',
  templateUrl: 'header.html'
})
export class HeaderComponent {

  constructor() {
  }
}



// WEBPACK FOOTER //
// ./src/components/header/header.ts